"use client";

import Link from "next/link";
import Script from "next/script";
import { breadcrumbsToJsonLd } from "@/utils/breadcrumbs";

/**
 * Accessible, minimal markup; includes JSON-LD.
 * - Last item renders as <span aria-current="page">
 */
export default function Breadcrumbs({ items = [], className = "" }) {
  if (!items?.length) return null;
  const jsonLd = breadcrumbsToJsonLd(items);

  return (
    <>
      <nav aria-label="Breadcrumb" className={className}>
        <ol className="flex flex-wrap gap-2 text-sm">
          {items.map((c, idx) => {
            const isLast = idx === items.length - 1;
            const common = "inline-flex items-center";

            return (
              <li key={idx} className="flex items-center">
                {!isLast && c.href ? (
                  <Link href={c.href} className={`${common} hover:underline`}>
                    {c.label}
                  </Link>
                ) : (
                  <span className={common} aria-current="page" title={c.label}>
                    {c.label}
                  </span>
                )}
                {!isLast && <span className="mx-2 select-none">/</span>}
              </li>
            );
          })}
        </ol>
      </nav>

      <Script
        id="breadcrumbs-jsonld"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}
